import { useConditionRefinement } from '../../hooks/useConditionRefinement';
import EditorConditionBase from './EditorConditionBase';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionRefinement = props => {
  const {
    condition,
    filterFamily,
    inputUse,
    onConditionChange,
    emptyRefinementCondition
  } = props;
  const {
    disableRefinement,
    isChecked,
    isRefinementEnabled,
    onCheckboxChange,
    onRefinementConditionDelete,
    onRefinementConditionOperatorChange,
    onRefinementConditionValueChange,
    refinementCondition,
    refinementLabel,
    tooltipText
  } = useConditionRefinement(condition, emptyRefinementCondition, filterFamily, onConditionChange);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: tooltipText,
      disabled: !disableRefinement,
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: isChecked,
        onChange: onCheckboxChange,
        disabled: disableRefinement,
        children: refinementLabel
      })
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(EditorConditionBase, {
        condition: refinementCondition,
        filterFamily: filterFamily,
        inputUse: inputUse,
        onConditionDelete: onRefinementConditionDelete,
        onConditionOperatorChange: onRefinementConditionOperatorChange,
        onConditionValueChange: onRefinementConditionValueChange,
        isRefinement: true,
        isRefinementEnabled: isRefinementEnabled
      })
    })]
  });
};
export default EditorConditionRefinement;